import { PlessViewUtilsSub } from 'src/app/commons/kymw00/pless-view-utils-sub.service';
import { KYMW1504Component } from './kymw1504.component';
import { MarkFileListVo } from './vo/mark-file-list.model';

/**
 * マーク登録画面の値を管理するクラス
 *
 * @export KYMW1504Model
 * @class KYMW1504Model
 */
export class KYMW1504Model {

  kymw1504Component: KYMW1504Component;

  /** マークグループリスト */
  public markGroupList = [];
  public selectedMarkGroup: string = <string>'';

  /** 販売促進マークリスト */
  public supplyPromoteMarkDivList = [];
  public selectedSupplyPromoteMarkDiv: string = <string>'';

  /** 登録可能マークファイルリスト */
  public canRegistMarFilekList = [];
  /** 登録可能マークファイルリスト件数 */
  public canRegistMarkFileNum = 0;
  /** プレビュー対象の登録可能マークファイル */
  public canRegistMarkFileUrl: string = <string>'';

  /**
   * マークグループコードに対応するマークグループ名を取得する
   *
   * @param markGroupCode マークグループコード
   * @return マークグループ名
   */
  public getMarkGroupCaption(markGroupCode: string): string {
    const target = this.markGroupList.find((markGroup) => {
      return (markGroupCode === markGroup.MarkGroupCode);
    });

    return (PlessViewUtilsSub.isEmpty(target)) ? '' : target.Caption;
  }

  /**
   * 供給促進マーク区分に対応する名称を取得する
   *
   * @param codeValue 供給促進マーク区分
   * @return 供給促進マーク区分の名称
   */
  public getSupplyPromoteMarkDivName(codeValue: string): string {
    const target = this.supplyPromoteMarkDivList.find((supplyPromoteMarkDiv) => {
      return (codeValue === supplyPromoteMarkDiv.CodeValue);
    });

    return (PlessViewUtilsSub.isEmpty(target)) ? '' : target.CodeName;
  }

  /**
   * データグリッド「登録可能マークファイル一覧」の設定
   *
   * @param {*} serverData
   * @returns {void}
   * @memberof KYMW15004Model
   */
  public updateCanRegistMarkFileList(serverData: any): void {
    if (PlessViewUtilsSub.isEmpty(serverData)) {
      this.canRegistMarFilekList = [];
      this.canRegistMarkFileNum = 0;
      return;
    }

    // 登録可能マークファイルリストのデータの編集
    this.canRegistMarFilekList = serverData.reduce((viewList, data) => {
      viewList.push(new MarkFileListVo(
        PlessViewUtilsSub.zeroPadding(3, data.MarkCode),
        data.MarkCodeBranch,
        data.MarkFileName,
        data.MarkFileUrl,
        data.MarkGroupCode,
        this.getMarkGroupCaption(data.MarkGroupCode),
        data.MarkName,
        data.SupplyPromoteMarkDiv,
        this.getSupplyPromoteMarkDivName(data.SupplyPromoteMarkDiv),
        PlessViewUtilsSub.editDate(data.RegistDate, '2'),
      ));
      return viewList;
    },[]);

    this.canRegistMarkFileNum = this.canRegistMarFilekList.length;
  }

  /**
   * マークグループリストを更新する
   *
   * @param serverData マークグループリストのサーバ取得データ
   * @memberof KYMW1504Component
   */
  public updateMarkGroupListForCmb(serverData: any) {
    this.markGroupList = this.createComboboxArray(serverData, { MarkGroupCode: '', Caption: '' });
  }

  /**
   * 販売促進マークリストを更新する
   *
   * @param serverData 販売促進マークリストのサーバ取得データ
   * @memberof KYMW1504Component
   */
  public updateSupplyPromoteMarkDivListForCmb(serverData: any): void {
    this.supplyPromoteMarkDivList = this.createComboboxArray(serverData, { CodeValue: '', CodeName: '' });
  }

  /**
   * コンボボックス用配列の作成
   *
   * @private
   * @param {*} comboboxDataArray サーバから取得されたコンボボックス用データ
   * @param {*} blankData 先頭の空白用データ
   * @returns {*}　コンボボックス用配列
   * @memberof KYMW1504Component
   */
  private createComboboxArray(comboboxDataArray: any, blankData: any): any {
    let tempList = [];
    tempList = comboboxDataArray;
    tempList.splice(0, 0, blankData);
    return tempList;
  }
}
